<div [hidden]="showSpinner">
  <ng-container *ngIf="dataReady && !loginCompleting">
    <cudc-ea-authenticate
      class="bl-margin-x--auto bl-margin-top--48"
      [widgetContext]="widgetContext"
      (widgetExportDataChange)="receivedDataHandler($event)"
    ></cudc-ea-authenticate>
  </ng-container>
</div>

<div
  *ngIf="loginCompleting"
  class="bl-margin-x--auto bl-margin-top--48 bl-font-color--black bl-display--flex bl-align-items--center bl-justify-content--center bl-border-radius--16 bl-bg-color--white bl-padding-y--48 message-container"
>
  <span class="bl-text-style--display-6">Retrieving your permissions...</span>
</div>
